<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { isDev } from '@goldcast/utils';
import { defineComponent } from 'vue';

import { getAppEnvironment } from '@/utils';

const APP_NAME = isDev(getAppEnvironment()) ? 'Goldcast Studio [DEV]' : 'Goldcast Studio';

export default defineComponent({
  name: 'DocumentTitleProvider',
  props: {
    title: {
      type: String
    },
    titleSuffix: {
      type: String
    }
  },
  mounted() {
    this.setTitle(this.title, this.titleSuffix);
  },
  beforeUnmount() {
    this.unsetTitle();
  },
  watch: {
    title() {
      this.setTitle(this.title, this.titleSuffix);
    }
  },
  methods: {
    setTitle(title: string | undefined, titleSuffix: string | undefined) {
      if (title && titleSuffix) {
        document.title = `${title} - ${titleSuffix} | ${APP_NAME}`;
      } else if (title && !titleSuffix) {
        document.title = `${title} | ${APP_NAME}`;
      } else {
        this.unsetTitle();
      }
    },
    unsetTitle() {
      document.title = APP_NAME;
    }
  }
});
</script>
